const EMPTY_NAV_URL = '';
const FORCE_RELOAD = true;
export const FORCE_REDIRECT_ARGS = [EMPTY_NAV_URL, FORCE_RELOAD];

export const REDIRECT_BASE_404 = '/404';
export const REDIRECT_NOT_ACCEPTING_BOOKING = `${REDIRECT_BASE_404}?notAcceptingBooking=true`;
export const REDIRECT_WITH_ACCOUNT_DETAILS = `${REDIRECT_BASE_404}?withAccountDetails=true`;
